import { render, staticRenderFns } from "./LandCoverAnalysisDetails.vue?vue&type=template&id=ca36574a&scoped=true"
import script from "./LandCoverAnalysisDetails.vue?vue&type=script&lang=js"
export * from "./LandCoverAnalysisDetails.vue?vue&type=script&lang=js"
import style1 from "./LandCoverAnalysisDetails.vue?vue&type=style&index=1&id=ca36574a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca36574a",
  null
  
)

export default component.exports